export const BADGES = {
    ECO_CONSCIOUS: 512,
    LUXURY: 553,
    MARSAI_MARTIN: 552,
    NEW: 'new',
    NEW_ARRIVAL: 71,
    PREMIUM: 127,
    RATED: 231,
    SALE: 131,
    UPSELLS: 'secondFrame',
    WEEKEND: 187,
};

/**
 * Waiting the task https://jira.gusadev.com/browse/BAC-2971
 */
export const SALE_BADGES = ['isSale', 'special-sale'];

export const BADGES_TITLES_CART = {
    'badge-luxury': BADGES.PREMIUM,
    'badge-new-arrivals': BADGES.NEW_ARRIVAL,
    isSale: BADGES.SALE,
    secondFrame: BADGES.UPSELLS,
    'special-sale': BADGES.SALE,
};
